import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'wouter';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Statistic from './Statistic';
import StatisticsFilter from './StatisticsFilter';
import { loadClients } from '../../clients/clientsReducer';
import clientSelector from '../../clients/clientSelector';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import { getClientPayloadType, getDocumentationPayloadType } from '../../common/helpers/payloadType';
import statistics from '../../common/helpers/statistics';
import type { AppDispatch } from '../../store';
import type { FhbfStatisticType } from '../../common/types/statistics/fhbfStatistics';
import type { StatisticsFilter as StatisticsFilterType } from '../../common/types/statistics/statistics';
import { loadDocumentation } from '../../documentation/documentationReducer';

const reactAppVersion = process.env.REACT_APP_VERSION;

function Statistics({ filterStartYear }: { filterStartYear: number }) {
  const dispatch: AppDispatch = useDispatch();
  const [location] = useLocation();
  const clientStatus = useSelector(clientSelector.getStatus);
  const [statistic, setStatistic] = React.useState<FhbfStatisticType | null>();
  const [statisticFilter, setStatisticFilter] = React.useState<StatisticsFilterType>(statistics.defaultFilter);

  React.useEffect(() => {
    const clientPayloadType = getClientPayloadType(location);
    const documentationPayloadType = getDocumentationPayloadType(location);
    dispatch(loadClients(clientPayloadType));
    dispatch(loadDocumentation(documentationPayloadType));
  }, []);

  return (
    <Stack
      px={3}
      py={4}
      height='100%'
      sx={{ display: 'block' }}
      overflow='auto scroll'
      className={`wrapper-${reactAppVersion}`}
    >
      <Typography className='headline' fontSize='1.5rem'>
        Statistik
      </Typography>
      <StatisticsFilter
        filterStartYear={filterStartYear}
        location={location}
        setStatistic={setStatistic}
        statisticFilter={statisticFilter}
        setStatisticFilter={setStatisticFilter}
      />
      {clientStatus === 'loading' ? (
        <LoadingIndicator />
      ) : (
        <Stack spacing={6} sx={{ display: 'block' }}>
          <Statistic statistic={statistic} statisticFilter={statisticFilter} />
        </Stack>
      )}
    </Stack>
  );
}

export default Statistics;
